"use strict";
require('../../company/comments/CompanyFeedActivity.js');
require('../../company/comments/CompanyFeedActivityDirective.js');


CompanyGuestCommentsCtrl.$inject = [
  '$scope',
  'comments',
  'messages',
  'activities'];
function CompanyGuestCommentsCtrl(
  $scope,
  comments,
  messages,
  activities) {
  $scope.comments = comments;
  $scope.messages = messages;
  $scope.activities= activities;
}

CompanyGuestCommentsCtrl.resolve = {
  comments: ['$stateParams', 'CompanyCommentsService' , function($stateParams, CompanyCommentsService) {
    return CompanyCommentsService.query({companyId: $stateParams.companyId, limit: 4}).$promise;
  }],
  messages: ['$stateParams', 'CompanyMessageService', 'info', function($stateParams, CompanyMessageService, info) {
    if (info.features.blogs === false) {
      return false;
    }
    return CompanyMessageService.query({companyId: $stateParams.companyId, limit: 4}).$promise;
  }],
  info: ['$stateParams', 'CompanyInfoService', function($stateParams, CompanyInfoService){
    return CompanyInfoService.get({companyId: $stateParams.companyId}).$promise;
  }],
  activities: ['$stateParams', 'CompanyFeedActivity', 'info', function($stateParams, CompanyFeedActivity, info) {
    return new CompanyFeedActivity($stateParams.companyId, info.features.blogs);
  }]
};

module.exports = CompanyGuestCommentsCtrl;

angular.module("dokiv")
  .controller("CompanyGuestCommentsCtrl", CompanyGuestCommentsCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/comments/CompanyGuestCommentsCtrl.js
// module id = 286
// module chunks = 0